<template>
  <div class="content-wrapper">
    <app-breadcrumb :page-title="$t('dashboard')"
                    :directory="$t('dashboard')"
                    :icon="'pie-chart'"/>
    <div class="row">
      <div class="col-xl-12 mb-primary">
        <div class="card card-with-shadow border-0">
          <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">{{ $t('marketing_chanel') }}</h5>
            <ul class="nav tab-filter-menu justify-content-flex-end">
              <li class="nav-item" v-for="(item, index) in chartFilterOptions"
                  :key="index">
                <a href="#"
                   class="nav-link py-0"
                   :class="[dealsFilter == item.id ? 'active' : index === 0 && dealsFilter === '' ? 'active': '']"
                   @click.prevent="dealsFilterValue(item.id)">
                  {{ item.value }}
                </a>
              </li>
            </ul>
          </div>

          <div class="card-body">
            <app-overlay-loader v-if="lineChartLoad"/>
            <template v-else>
            <app-chart class="mb-primary"
                       type="custom-line-chart"
                       :height="230"
                       :labels="lineChartLabels"
                       :data-sets="lineChartData"/>

            <div class="chart-data-list d-flex flex-wrap justify-content-center">
			  <div class="data-group-item" style="color: #4466F2;">
                <span class="square" style="background-color: #4466F2;"/>
                {{ $t('traf_rec') }}

                <span class="value">{{ trafDeal }}</span>
              </div>
              <div class="data-group-item" style="color: #27AE60;">
                <span class="square" style="background-color: #27AE60;"/>
                {{ $t('itraf_rec') }}

                <span class="value">{{ itrafDeal }}</span>
              </div>
              <div class="data-group-item" style="color: #FC5710;">
                <span class="square" style="background-color: #FC5710;"/>
                {{ $t('ftraf_rec') }}

                <span class="value">{{ ftrafDeal }}</span>
              </div>
			  <div class="data-group-item" style="color: #fff000;">
                <span class="square" style="background-color: #fff000;"/>
                {{ $t('ntraf_rec') }}

                <span class="value">{{ ntrafDeal }}</span>
              </div>
			  <div class="data-group-item" style="color: #A45FFD;">
                <span class="square" style="background-color: #A45FFD;"/>
                {{ $t('mtraf_rec') }}

                <span class="value">{{ mtrafDeal }}</span>
              </div>
			  <div class="data-group-item" style="color: #08cbd7;">
                <span class="square" style="background-color: #08cbd7;"/>
                {{ $t('etraf_rec') }}

                <span class="value">{{ etrafDeal }}</span>
              </div>	
              <div class="data-group-item" style="color: #da0037;">
                <span class="square" style="background-color: #da0037;"/>
                {{ $t('total') }}

                <span class="value">{{ totalDealOverview }}</span>
              </div>
            </div>
            </template>
          </div>
        </div>
      </div>
      <div class="col-xl-6 mb-primary">
        <div class="card card-with-shadow border-0">
          <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">{{ $t('marketing_chanel_pie') }}</h5>
            <div class="badge dashboard-badge badge-pill text-capitalize">{{totalDeal}}</div>
          </div>
          <app-overlay-loader v-if="dataload"/>
          <div class="card-body" v-else>
			  <div class="row">
			  <div class="col-xl-5">
				   <div class="chart-data-list">
              <div class="">
                <div v-for="(item, index) in totalDealsChartElement" :key="index" class="row">
                  <div class="data-group-item" :style="item.color">
                    <span class="square" :style="item.background_color"/>
                    {{ item.key }}
                    <span class="value">{{ item.value }} ({{ Math.round(item.value * 100 / totalDeal) }}%)</span>
                  </div>
                </div>
              </div>
            </div>
			  </div>
			  <div class="col-xl-7">
				  <app-chart class="mb-primary"
                       type="dough-chart"
                       :height="230"
                       :labels="totalDealsLabels"
                       :data-sets="totalDealsDataSet"/>
			  </div>
            </div>
           
          </div>
        </div>
      </div>
		<div class="col-xl-6 mb-primary">
        <div class="card card-with-shadow border-0">
          <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">{{ $t('marketing_sex') }}</h5>
            <div class="badge dashboard-badge badge-pill text-capitalize">{{totalDealSex}}</div>
          </div>
          <app-overlay-loader v-if="dataload"/>
          <div class="card-body" v-else>
			  <div class="row">
			  <div class="col-xl-5">
				   <div class="chart-data-list">
              <div class="">
                <div v-for="(item, index) in totalDealsChartElementSex" :key="index" class="row">
                  <div class="data-group-item" :style="item.color">
                    <span class="square" :style="item.background_color"/>
                    {{ item.key }}
                    <span class="value">{{ item.value }} ({{ Math.round(item.value * 100 / totalDealSex) }}%)</span>
                  </div>
                </div>
              </div>
            </div>
			  </div>
			  <div class="col-xl-7">
				  <app-chart class="mb-primary"
                       type="dough-chart"
                       :height="230"
                       :labels="totalDealsLabels"
                       :data-sets="totalDealsDataSetSex"/>
			  </div>
            </div>
           
          </div>
        </div>
      </div>
    </div>
    <div class="row">
		<div class="col-xl-6 mb-primary">
        <div class="card card-with-shadow border-0">
          <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">{{ $t('marketing_chanel_type') }}</h5>
              <div class="badge dashboard-badge badge-pill text-capitalize">{{totalDeal}}</div>
          </div>
          <app-overlay-loader v-if="pipelineDataload"/>
          <div class="card-body" v-else>
            <app-chart type="bar-chart"
                       :height="380"
                       :labels="HorizontalLineChartLabel"
                       :data-sets="HorizontalLineChartData"/>
          </div>
        </div>
      </div>
		<div class="col-xl-6 mb-primary">
        <div class="card card-with-shadow border-0">
          <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">{{ $t('marketing_age') }}</h5>
			    <div class="badge dashboard-badge badge-pill text-capitalize">{{totalDeal}}</div>
          </div>
          <app-overlay-loader v-if="pipelineDataload"/>
          <div class="card-body" v-else>
            <app-chart type="bar-chart"
                       :height="380"
                       :labels="HorizontalLineChartLabelAge"
                       :data-sets="HorizontalLineChartDataAge"/>
          </div>
        </div>
      </div>

   
    </div>
  
  </div>
</template>

<script>

import {FormMixin} from "../../../../core/mixins/form/FormMixin";

export default {
  name: "Dashboard",
  mixins: [FormMixin],
  data() {
    return {
      dataload:false,
      lineChartLoad:false,
      pipelineDataload:false,

      // deals Overview - line chart
      chartFilterOptions: [
        {"id": "last_seven_days", "value": this.$t("last_7_days")},
        {"id": "this_week", "value": this.$t("this_week")},
        {"id": "last_week", "value": this.$t("last_week")},
        {"id": "this_month", "value": this.$t("this_month")},
        {"id": "last_month", "value": this.$t("last_month")},
        {"id": "this_year", "value": this.$t("this_year")},
        {"id": "total", "value": this.$t("total")}
      ],
      dealsFilter: 'last_seven_days',
      lineChartLabels: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      lineChartData: [
        {
          "title": "Rec",
          "fill": false,
          "borderWidth": 1.5,
          "borderColor": "#4466F2",
          "backgroundColor": "#4466F2",
          data: [20,30,40,50,60,20,50],
        },
        {
          "title": "Internet",
          "fill": false,
          "borderWidth": 1.5,
          "borderColor": "#27AE60",
          "backgroundColor": "#27AE60",
          data: [68, 57, 41, 66, 43, 59, 51]
        },
        {
          "title": "Facebook",
          "fill": false,
          "borderWidth": 1.5,
          "borderColor": "#FC5710",
          "backgroundColor": "#FC5710",
          data: [50,100,110,50,60,20,50]
        },
		{
          "title": "Instagram",
          "fill": false,
          "borderWidth": 1.5,
          "borderColor": "#fff000",
          "backgroundColor": "#fff000",
          data: [50,100,110,50,60,20,50]
        },
		 {
          "title": "Mess",
          "fill": false,
          "borderWidth": 1.5,
          "borderColor": "#A45FFD",
          "backgroundColor": "#A45FFD",
          data: [50,100,110,50,60,20,50]
        },
		{
          "title": "Ex",
          "fill": false,
          "borderWidth": 1.5,
          "borderColor": "#08cbd7",
          "backgroundColor": "#08cbd7",
          data: [50,100,110,50,60,20,50]
        },
        {
          "title": "Total",
          "fill": false,
          "borderWidth": 1.5,
          "borderColor": "#da0037",
          "backgroundColor": "#da0037",
          data: [10,30,30,25,10,5,6]
        }
      ],
      // Total deals - pie chart
      totalDealsLabels: ['Traf', 'Itraf', 'FTraf', 'NTraf', 'MTraf', 'ETraf'],
      totalDealsDataSet: [
        {
          backgroundColor: [
            '#4466F2',
            '#27AE60',
            '#FC5710',
			"#fff000",
			"#A45FFD",
			"#08cbd7",
			  
          ],
          data: [],
          borderWidth: 0,
        }
      ],
      totalDealsChartElement: [
        {
          "key":  this.$t('traf_rec'),
           value: 20,
          "background_color": "background-color: #4466F2;",
          "color": "color: #4466F2;"
        },
        {
          "key": this.$t('itraf_rec'),
          value: 25,
          "background_color": "background-color: #27AE60;",
          "color": "color: #27AE60;"
        },
        {
          "key": this.$t('ftraf_rec'),
          value: 40,
          "background_color": "background-color: #FC5710;",
          "color": "color: #FC5710;"
        },
		   {
          "key": this.$t('ntraf_rec'),
          value: 40,
          "background_color": "background-color: #fff000;",
          "color": "color: #fff000;"
        },
		   {
          "key": this.$t('mtraf_rec'),
          value: 40,
          "background_color": "background-color: #A45FFD;",
          "color": "color: #A45FFD;"
        },
		  {
          "key": this.$t('etraf_rec'),
          value: 40,
          "background_color": "background-color: #08cbd7;",
          "color": "color: #08cbd7;"
        }
      ],
		
		
		
		// Total deals - pie chart
      totalDealsLabelsSex: ['Traf', 'Itraf'],
      totalDealsDataSetSex: [
        {
          backgroundColor: [
            '#4466F2',
            '#27AE60',
          ],
          data: [],
          borderWidth: 0,
        }
      ],
      totalDealsChartElementSex: [
        {
          "key":  this.$t('men'),
           value: 20,
          "background_color": "background-color: #4466F2;",
          "color": "color: #4466F2;"
        },
        {
          "key": this.$t('women'),
          value: 25,
          "background_color": "background-color: #27AE60;",
          "color": "color: #27AE60;"
        }
      ],
		
		
		
		
		
		
      // Total Contacts - App widget
      contactList: [
        {
          icon: 'briefcase',
          title: this.$t("total_organizations"),
          value: 10247
        },
        {
          icon: 'user',
          title: this.$t("people_organizations"),
          value: 10247
        },
        {
          icon: 'message-circle',
          title: this.$t("fund_organizations"),
          value: 10247
        }
      ],
      // Total Employees - App widget
      employeesList: [
        {
          icon: 'award',
          title: 'Works as owner',
          value: 10247
        },
        {
          icon: 'user-plus',
          title: 'Works as collaborators',
          value: 10247
        },
        {
          icon: 'users',
          title: 'Works as both owner and collaborators',
          value: 10247
        }
      ],
      // Deals on pipeline - Horizontal line chart
      lineChartFilterOption: [
       
        {"id": "status_won", "value": "Won"},
       
      ],
      lineChartFilterValue: 'status_won',
      HorizontalLineChartLabel: [],
      HorizontalLineChartData: [
        {
          label: 'Data',
          backgroundColor: [],
          barThickness: 25,
          data: [],
          borderWidth: 0,
        }
      ],
		
		
		
		HorizontalLineChartLabelAge: ['0-5', '5-16', '16-25', '25-40', 'Пенсионер'],
		
		HorizontalLineChartDataAge: [
        {
          label: 'Data',
          backgroundColor: ["#00C754", "#00C754", "#00C754", "#00C754", "#00C754"],
          barThickness: 25,
          data: [],
          borderWidth: 0,
        }
      ],
      // Top five owners - bar chart
      barChartLabel: [],
      barChartData: [
        {
          label: 'Data',
          backgroundColor: "#4466F2",
          barThickness: 15,
          data: [],
          borderWidth: 0,
        }
      ],

      totalContact: null,
      totalEmployees: null,
      sendingRate: null,
      acceptanceRate: null,
      totalSendProposal: null,
      totalAcceptedProposal: null,
      totalPipeline: null,
      totalDeal: null,
		totalDealSex: null,
      openDeal: null,
	  trafDeal: null,
	  itrafDeal: null,
	  ftrafDeal: null,
	  ntrafDeal: null,
	  mtrafDeal: null,
	  etrafDeal: null,
      wonDeal: null,
      lostDeal: null,
      totalDealOverview: null

    }
  },
  mounted() {
    this.dashboardGetData();
     this.dealOverViewLineChartData();
  },
  methods: {
    dashboardGetData() {
      this.dataload = true;
      this.pipelineDataload = true;
      this.axiosGet(`crm/dashboard?status=${this.lineChartFilterValue}`).then((response) => {

        // Deal Chart
         this.totalDeal = response.data.total_deal // Total Deal
         this.totalDealsDataSet.forEach((value, index) => {
           value.data = response.data.deals_chart
         })

        this.totalDealsChartElement.forEach((element, index) =>{
          element.value = response.data.total_deals_chart_element[index].value

        });
		  
		  
		  
		// Deal Chart
         this.totalDealSex = response.data.total_deal_sex // Total Deal
         this.totalDealsDataSetSex.forEach((value, index) => {
           value.data = response.data.deals_chart_sex
         })

        this.totalDealsChartElementSex.forEach((element, index) =>{
          element.value = response.data.total_deals_chart_element_sex[index].value

        });
		  
		  
		  

        // Contact

        this.totalContact = response.data.total_contact
	
        this.contactList.forEach((item, index) => {
          item.value = response.data.contacts[index].value
        })

        // Employees
        this.totalEmployees = response.data.total_employee
        this.employeesList.forEach((employee, index) => {
          employee.value = response.data.employees[index].value
        })

        // Total send proposal
        this.totalSendProposal = response.data.total_send_proposal

        // total accepted proposal
        this.totalAcceptedProposal = response.data.total_accepted_proposal

        // Sending Rate
        this.sendingRate = response.data.sending_rate

        //acceptance rate
        this.acceptanceRate = response.data.acceptance_rate

        // Total Pipeline

        this.totalPipeline = response.data.total_pipeline

        // Deal on Pipeline

        this.HorizontalLineChartLabel = response.data.deals_on_pipeline_name

        this.HorizontalLineChartData.forEach((bgColor, index) => {
          bgColor.backgroundColor = response.data.background_color;
        })

        this.HorizontalLineChartData.forEach((element, index) => {

          element.data =  response.data.pipeline_total_deals

        })
        this.HorizontalLineChartData[0].data.push(0);
		  
		  
		  
		  
		  // Deal on Age

       

        this.HorizontalLineChartDataAge.forEach((element, index) => {

          element.data =  response.data.pipeline_total_deals_age

        })
        this.HorizontalLineChartDataAge[0].data.push(0);
		  
		  
		  

        // Top Five owner name
        this.barChartLabel = response.data.top_five_owners_name
        this.barChartData.forEach((element, index) => {
          element.data = response.data.five_owner_deal
        })
        this.barChartData[0].data.push(0)
      }).finally(() => {
        this.dataload = false;
        this.pipelineDataload = false;
      })
    },

    dealOverViewLineChartData(){
      this.lineChartLoad = true;
      this.axiosGet(`crm/deal-overview?${this.dealsFilter}`).then(response => {

        this.lineChartData.forEach((element, index) => {
          element.data = response.data.deal_over_view[index]
        })

       
		this.trafDeal = response.data.traf_deal // Total Open Deal
		this.itrafDeal = response.data.itraf_deal // Total Open Deal
		this.ftrafDeal = response.data.ftraf_deal // Total Open Deal
		this.ntrafDeal = response.data.ntraf_deal // Total Open Deal
		this.mtrafDeal = response.data.mtraf_deal // Total Open Deal
		this.etrafDeal = response.data.etraf_deal // Total Open Deal
        this.wonDeal = response.data.won_deal // Total won Deal
        this.lostDeal = response.data.lost_deal // Total lost Deal
        this.totalDealOverview = response.data.total_deal_overview_ch

      }).finally(() => {
           this.lineChartLoad = false;
      })
    },

    dealsFilterValue(value) {
      this.dealsFilter = value;
      this.lineChartLoad = true;
      this.axiosGet(`crm/deal-overview?${this.dealsFilter}`).then(response => {

        if (this.dealsFilter == 'last_seven_days' || this.dealsFilter == 'this_week' || this.dealsFilter == 'last_week'){
          this.lineChartLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

        }else if(this.dealsFilter == 'this_month' || this.dealsFilter == 'last_month'){

          this.lineChartLabels = response.data.deal_over_view[0].map((e, i) => {return i+1})

        }else if (this.dealsFilter == 'this_year' || this.dealsFilter == 'total'){
          this.lineChartLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        }

        this.lineChartData.forEach((element, index) => {
          element.data = response.data.deal_over_view[index]
        })

       
		this.trafDeal = response.data.traf_deal // Total Open Deal
		this.itrafDeal = response.data.itraf_deal // Total Open Deal
		this.ftrafDeal = response.data.ftraf_deal // Total Open Deal
		this.ntrafDeal = response.data.ntraf_deal // Total Open Deal
		this.mtrafDeal = response.data.mtraf_deal // Total Open Deal
		this.etrafDeal = response.data.etraf_deal // Total Open Deal
        this.wonDeal = response.data.won_deal // Total won Deal
        this.lostDeal = response.data.lost_deal // Total lost Deal
        this.totalDealOverview = response.data.total_deal_overview_ch
      }).finally(() => {
        this.lineChartLoad = false
      })
    },

    getLineChartFilterValue(value) {
      this.lineChartFilterValue = value;
      this.pipelineDataload = true;
      this.axiosGet(`crm/dashboard?status=${this.lineChartFilterValue}`).then((response) => {

        this.HorizontalLineChartLabel = response.data.deals_on_pipeline_name

        this.HorizontalLineChartData.forEach((bgColor, index) => {
          bgColor.backgroundColor = response.data.background_color;
        })

        this.HorizontalLineChartData.forEach((element, index) => {
          element.data =  response.data.pipeline_total_deals
        })
        this.HorizontalLineChartData[0].data.push(0);

      }).finally(() => {
        this.pipelineDataload = false;
      })
    }
  }
}
</script>
